import { FC } from "react";
import { DraftAsset, FieldTypes } from "lib/types";
import { DraftLinkForm } from './draftLinkForm';
import { DraftUnknownForm } from "./draftUnknownForm";
import { DraftTextForm } from "./draftTextForm";
import { DraftPromptForm } from "./draftPromptForm";
import { DraftHtmlForm } from "./draftHtmlForm";
import { Modal } from "components";

type Props = {
  isOpen: boolean;
  asset: DraftAsset;
  onClose: () => void;
}

export const DraftAssetModal: FC<Props> = (props) => {
  const getTitle = (): string => {
    switch (props.asset.type) {
      case FieldTypes.HTML:
        return 'Add HTML asset'
      case FieldTypes.LINK:
        return 'Add link asset'
      case FieldTypes.TEXT:
        return 'Add text asset'
      case FieldTypes.PROMPT:
        return 'Add a dropzone'
      default:
        return 'Add Asset'
    }
  }

  const getModal = (): JSX.Element => {
    switch (props.asset.type) {
      case FieldTypes.HTML:
        return <DraftHtmlForm {...props} />
      case FieldTypes.LINK:
        return <DraftLinkForm {...props} />
      case FieldTypes.TEXT:
        return <DraftTextForm {...props} />
      case FieldTypes.PROMPT:
        return <DraftPromptForm {...props} />
      default:
        return <DraftUnknownForm {...props} />
    }
  };

  return (
    <Modal title={getTitle()} {...props} size={"lg"}>
      { getModal() }
    </Modal>
  )
};
